import {Group} from "@mantine/core";
import {ObjectDocumentAssocEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import { getFormattedDateTime } from "../../date/FormattedDateTime/FormattedDateTime";

type Props = {
  value: ObjectDocumentAssocEntity
  withDesc?: boolean
  withDate?: boolean
}

export const FormattedObjectDocumentAssoc = (props: Props) => {
  const {value, withDesc = false, withDate = true} = props;

  const {t} = useTranslation(["common"])

  return (
    <Group spacing="xs">
      {value.fileName ?? value.description ?? t("common.shared.unknown", "Unknown")}
      {(value.fileName && withDesc) &&
        <>
          {" - "}
          {value.description}
        </>
      }
      {(withDate && value.createDttm) &&
        <>
          {" ("}
          {getFormattedDateTime(value.createDttm)}
          {")"}
        </>
      }
    </Group>
  );
};
